<template lang="pug">
  #fast-links
    .container
      titulo.-upper.-withbar Links Importantes
      ul.list
        li.item: a(href="http://idg.receita.fazenda.gov.br/" target="_blank") Receita
        li.item: a(href="http://www.crcrn.org.br/" target="_blank") CRC/RN
        li.item: a(href="http://www.natal.rn.gov.br/" target="_blank") Prefeitura de Natal
        li.item: a(href="https://www.natal.rn.gov.br/semut/" target="_blank") SEMUT
        li.item: a(href="https://www.rn.gov.br/" target="_blank") Governo do RN
        li.item: a(href="http://www.set.rn.gov.br/" target="_blank") Secretaria de Tributação
</template>

<script>
import Titulo from 'COMPONENTS/ElementTitle'
export default {
  components: { Titulo }
}
</script>

<style lang="scss">
  #fast-links {
    padding: 40px 0;
    background-color: $color-green-light;

    .list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      margin: 0 auto;

      > .item {
        padding: 5px 10px;

        > a {
          font-size: 16px;
          color: $color-grey-dark;
          @extend %font_medium;
          @include iconFA('before', '\f0da');
          &:before { margin-right: 7px; color: $color-blue-dark; }
          &:hover { text-decoration: underline; color: $color-green-dark; }
        }
      }
    }

    &.--sidebar {
      padding: 0;
      margin: 40px 0;
      background: transparent;
      > .container {
        width: auto;
        > .list { width: auto; }
        > .list > .item { padding: 5px 10px }
      }
      .list { flex-direction: column; }
    }

    @include media(">tablet") {
      .list { width: 90%; flex-direction: row; }
      .list > .item { padding: 5px 20px; }
    }

    @include media(">320px", "<=tablet") {
      .list { flex-direction: row; }
      .list > .item { width: 50%; }
    }

    @include media(">=desktop") {
      > .container { padding: 0 }
    }
  }
</style>



// WEBPACK FOOTER //
// LinksImportantes.vue?bb65e43e